import { v4 as uuidv4 } from 'uuid'

export const CHLastLoad = 'CH_last_load'
export const CHSessionId = 'CH_sessionId'

const generateNewId = () => {
  const id = uuidv4()
  localStorage.setItem(CHSessionId, id)
  localStorage.setItem(CHLastLoad, new Date().toDateString())
  return id
}
export const getSessionId = () => {
  const lastLoad = localStorage.getItem(CHLastLoad)
  const sessionId = localStorage.getItem(CHSessionId)
  const millisecondsIn8Hours = 1000 * 60 * 60 * 8
  if (lastLoad && sessionId) {
    const greaterThan8Hours = Date.parse(new Date().toDateString()) - Date.parse(lastLoad) > millisecondsIn8Hours
    if (!greaterThan8Hours) { //  difference greater than 8 hours
      return sessionId
    }
  }
  return generateNewId()
}
